import moment from 'moment-timezone';

import Model from './Model';
import {IProductionData} from './Production';

import '../../sass/components/add_event_session.scss';

export type TEventType = 'session';
export type TEventStatus = 'draft' | 'published';
export type TTicketSystem = 'internal' | 'external';

export interface IEventData {
    id: number;
    type: TEventType;
    production_id: number;
    floor_plan_id: number;
    program_id: number | null;
    start_date: string;
    end_date: string;
    status: TEventStatus;
    public: number;
    ticket_system: TTicketSystem;
    ticket_sales_url: string | null;
    created_at: string;
    updated_at: string;
    name: string;
    color: string;
    production: IProductionData;
}

export default class Event extends Model<IEventData> {

    get id(): string {
        return '' + this.data.id;
    }

    get status(): TEventStatus {
        return this.data.status;
    }

    get public(): number {
        return this.data.public;
    }

    get name(): string {
        return (this.data.name ?? this.data.production.name);
    }

    get color(): string {
        return this.data.color;
    }

    get startDate(): moment.Moment {
        return moment(this.data.start_date);
    }

    get endDate(): moment.Moment {
        return moment(this.data.end_date);
    }

}
